import { LucideIcon } from 'lucide-react';

interface SectionHeaderProps {
  icon: LucideIcon;
  title: string;
}

export function SectionHeader({ icon: Icon, title }: SectionHeaderProps) {
  return (
    <div className='flex items-center gap-2 mb-4'>
      <Icon className='h-4 w-4 text-sd-muted-foreground' strokeWidth={1.5} />
      <h2 className='text-sm font-bold uppercase tracking-wider m-0'>{title}</h2>
    </div>
  );
}
